export const PAGE_MODE = {
  statistics: 'statistics',
  chart: 'chart',
  patients: 'patients',
}
